import { FormGroup, Validators, FormControl } from "@angular/forms";

export class Contact extends FormGroup {
  constructor(required: boolean) {
    const validators = required ? [Validators.required] : [];

    super({
      id: new FormControl<number>(0),
      firstName: new FormControl('', [...validators, Validators.maxLength(50)]),
      lastName: new FormControl('', [...validators, Validators.maxLength(50)]),
      email: new FormControl('', [...validators, Validators.email, Validators.maxLength(150), Validators.pattern(/^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]),
      phone: new FormControl('', [...validators, Validators.maxLength(30)]),
      company: new FormControl('', [...validators, Validators.maxLength(50)]),
      country: new FormControl('', [...validators])
    });
  }
}
